import { SVGProps } from "react";

export default function ZoomIcon(props: SVGProps<SVGSVGElement>) {
  const {
    height = 20,
    width = 20,
    fill = "#0052B4",
    stroke = "#1E54B7",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.99707 2.16663C14.3208 2.16663 17.8309 5.67593 17.8311 9.99963C17.8311 14.3235 14.3209 17.8336 9.99707 17.8336C5.67336 17.8334 2.16406 14.3234 2.16406 9.99963C2.16424 5.67603 5.67347 2.1668 9.99707 2.16663ZM5.96387 6.79163C5.26284 6.79173 4.69731 7.35719 4.69727 8.05823V10.3912C4.69727 11.9524 5.96523 13.2098 7.52539 13.1998H7.52637L10.5928 13.1754L10.5918 13.1744C11.2916 13.173 11.8555 12.6081 11.8555 11.9078V11.4078H11.8477V10.9264C11.9158 11.1129 12.0412 11.2774 12.2119 11.3912L13.8115 12.4576C14.4463 12.8808 15.2891 12.4213 15.2891 11.6666L15.2891 8.35022C15.2891 7.64254 14.5482 7.19419 13.9326 7.48987L13.8115 7.5592L12.2119 8.62561C12.0092 8.76076 11.8691 8.96665 11.8145 9.1969C11.6188 7.83704 10.4531 6.79163 9.03906 6.79163H5.96387Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
}
